import ReactMarkdown from "react-markdown"
import rehypeRaw from "rehype-raw"
import './styles/GenericPage.scss';

function GenericPage(props) {
    const {
        content,
    } = props;

    return (
        <main className='genericPage'>
            <ReactMarkdown rehypePlugins={[rehypeRaw]}>{content}</ReactMarkdown>
        </main>
    )
}

export default GenericPage;
